import { DrawerComponent } from '~/shared/ui/Drawer'
import { Content } from './Content'

type DailyDebitScheduleDrawerProps = {
  isShow: boolean
  onClose: () => void
}

export function DailyDebitScheduleDrawer({
  isShow,
  onClose,
}: DailyDebitScheduleDrawerProps) {
  return (
    <DrawerComponent isShow={isShow} onCancel={onClose}>
      <Content />
    </DrawerComponent>
  )
}
